import { useEffect, useState } from "react";
import AccessHelper from "../../helpers/access/AccessHelper";
import { OdinAccess } from "../../enums";
import { useLocation } from "react-router-dom";
import { Routes } from "../../../routes";

export const useGetAccess = (key: OdinAccess) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const isCheckIgnored = () => location.pathname.includes(Routes.freya);

  const defineAccess = async () => {
    if (isCheckIgnored()) {
      setLoading(false);
      return setHasAccess(true);
    }

    const accessAllowed = await AccessHelper.canBeAccessed(key);
    setHasAccess(accessAllowed);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    defineAccess();
  }, [location.pathname]);

  return { hasAccess, loading };
};
